import React, { useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { FaArrowLeft, FaTimes } from "react-icons/fa";
import "./CertificateModal.css";
import UpdateCertificateeModal from "../Service_certificare_update";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import url from "../../config/axios";
import { getAsset } from "../../helpers/helper";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { useNavigate } from "react-router-dom";
import { SuccessNotify, FailedNotify } from "../../constants/tostify";
import MainModal from "../ui/modal/modal";

const CertificateModal = ({
  show,
  setShowcertificate,
  id,
  certificateid,
  Dataloaderfun,
}) => {
  const [showModal, setShowModal] = useState(0);
  const handleClose = () => setShowModal(0);
  const navigate = useNavigate();
  const location = useLocation();
  const [shows, setShows] = useState(false);
  const [certificatedata, setCertificatedata] = useState();
const isOnlineView = location.pathname.startsWith("/services-online");
  
  useEffect(() => {
    if (!certificateid) return;

    url
      .get(`service/GetCertExpeSer/id/?id=${id}&certificateid=${certificateid}`)
      .then((res) => {
        setCertificatedata(res?.data?.data?.item);
      })
      .catch((err) => console.log(err));
  }, [certificateid]);

  const Deleteitem = () => {
    setShows(0);

    const deleteBody = {
      serviceMainId: id,
      certificateId: certificateid,
    };

    url
      .delete(`service/DeleteExpCerSer/id/`, { data: deleteBody })
      .then((response) => {
        if (response?.data?.message == "Deleted successfully") {
          Dataloaderfun();
          setShowcertificate(false);
          SuccessNotify("Certificate Deleted Successfully");
          navigate(`/services-profile/${id}`);
        }
      })
      .catch(() => {
        setShowcertificate(false);
        FailedNotify("Failed to Delete Try Again!");
      });
  };

  return (
    <>
      <UpdateCertificateeModal
        show={showModal}
        handleClose={() => setShowModal(0)}
        updateid={certificateid}
        serviceid={id}
      />

      {shows === 1 && (
        <MainModal
          variant="deleteModal"
          shows={shows}
          title="Delete"
          handleClose={handleClose}
          animation={true}
          handledelete={Deleteitem}
        />
      )}

      <Modal
        show={show}
        onHide={() => setShowcertificate(false)}
        centered
        size="lg"
        dialogClassName="certificate-modal"
      >
        <Modal.Body className="certificate-body">
          {/* Go Back Button */}
          <div className="certificate-header d-flex justify-content-end">
            <FaTimes
              className="close-icon"
              onClick={() => setShowcertificate(false)}
            />
          </div>

          {/* Certificate Info */}
          <div className="certificate-info">
            <h5 className="certificate-title">{certificatedata?.name}</h5>
            <p className="certificate-date">
              Issue date: {certificatedata?.issueDate}
            </p>
            <p className="certificate-date">Expiry date: 12-3-2024</p>
          </div>

          {/* Certificate Box */}
          <div className="certificate-box">
            <img
              src={getAsset(certificatedata?.img)}
              alt="Certificate"
              crossOrigin="anonymous"
              className="img-fluid"
              style={{ width: "100%", height: "100%" }}
            />
          </div>

          {/* Edit Button */}
         <div className="edit-btn-wrapper">
  {!isOnlineView && (
    <>
      <button
        className="d-flex align-items-center border rounded ps-3 pe-3 pt-1 pb-1 bg-red text-white"
        onClick={() => setShows(1)}
      >
        <DeleteOutlineOutlinedIcon />
        <span className="ps-1">Delete</span>
      </button>
      &nbsp;
      <Button
        variant="primary"
        className="edit-btn"
        onClick={() => {
          setShowcertificate(false);
          setShowModal(8);
        }}
      >
        Edit
      </Button>
    </>
  )}
</div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CertificateModal;
